import { NgModule } from "@angular/core";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { SharedModule } from "../shared.module";
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AgregarInteresesComponent } from './agregar-intereses/agregar-intereses.component';
import { MatDialogModule } from "@angular/material/dialog";
import { NgChartsModule } from 'ng2-charts';
import { AiChatComponent } from './ai-chat/ai-chat.component';
import { AiChatChartComponent } from './ai-chat/ai-chat-chart/ai-chat-chart.component';
import { AiChatOptionsComponent } from './ai-chat/ai-chat-options/ai-chat-options.component';
import { AiChatDownloadComponent } from './ai-chat/ai-chat-download/ai-chat-download.component';

@NgModule({
  declarations: [FileUploadComponent, BreadcrumbComponent, AgregarInteresesComponent, AiChatComponent, AiChatChartComponent, AiChatOptionsComponent, AiChatDownloadComponent],
  imports: [SharedModule, PdfViewerModule, MatDialogModule, NgChartsModule],
  exports: [FileUploadComponent, BreadcrumbComponent, AiChatComponent, AiChatChartComponent, AiChatOptionsComponent, AiChatDownloadComponent, SharedModule],
})
export class ComponentsModule {}
